import { v4 as uuidv4 } from 'uuid'
/**
 * Truncates a string to `maxLength` characters, appending `…` if truncated.
 */
export function truncate(value: string, maxLength = 12): string {
  return value.length > maxLength ? `${value.slice(0, maxLength - 1)}…` : value
}

/**
 * Combines first and last name into a full name, returning a fallback if both are empty.
 */
export function fullName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = '—',
): string {
  const name = `${firstName ?? ''} ${lastName ?? ''}`.trim()
  return name || fallback
}

/**
 * Converts a snake_case or SCREAMING_SNAKE_CASE key into Title Case.
 * e.g. "risk_profile_type" → "Risk Profile Type"
 *
 * Numeric ranges (`18_30`, `60_plus`) get an en-dash so age/amount bands
 * render as "18–30" / "60+" rather than "18 30" / "60 Plus".
 */
export function formatKey(key: string): string {
  const numericRange = key.match(/^(\d+)_(\d+)$/)
  if (numericRange) return `${numericRange[1]}–${numericRange[2]}`
  const openEnded = key.match(/^(\d+)_plus$/i)
  if (openEnded) return `${openEnded[1]}+`
  return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export function getIdempotencyKey(): string {
  return uuidv4()
}
